import React from 'react';
import ColorSwatch from './common/ColorSwatch';
import SelectDropdown from './common/SelectDropdown';
import '../../../Components/Common/typography.css';
import './DrawingToolBox.css';


interface DrawingToolBoxProps {
  color: string;       // hex with #
  dash: string;        // 's' | 'd'
  thickness: number;
  mode: number;        // 1=line (has Copy), 2/4/5/6=others
  onColorChange: (hex: string) => void;
  onStyleChange: (style: string) => void;
  onThicknessChange: (thickness: number) => void;
  onDelete: () => void;
  onCopy: () => void;
  onFinishEditing: () => void;
}

const DrawingToolBox: React.FC<DrawingToolBoxProps> = ({
  color,
  dash,
  thickness,
  mode,
  onColorChange,
  onStyleChange,
  onThicknessChange,
  onDelete,
  onCopy,
  onFinishEditing,
}) => (
  <div className="drawing-toolbox">
    <div className="drawing-toolbox-controls">
      <ColorSwatch
        color={`#${color.replace(/^#/, '')}`}
        onChange={(c) => onColorChange(c)}
        size={32}
      />
      <SelectDropdown
        type="linestyle"
        value={dash}
        onChange={(v) => onStyleChange(String(v))}
        className="drawing-toolbox-style"
      />
      <SelectDropdown
        type="thickstyle"
        value={thickness}
        onChange={(v) => onThicknessChange(Number(v))}
        className="drawing-toolbox-thickness"
      />
    </div>
    <div className="drawing-toolbox-actions">
      <button className="drawing-toolbox-btn body-s-regular" onClick={onDelete}>
        Delete
      </button>
      {mode === 1 && (
        <button className="drawing-toolbox-btn body-s-regular" onClick={onCopy}>
          Copy
        </button>
      )}
      <button
        className="drawing-toolbox-btn drawing-toolbox-btn--finish body-s-regular"
        onClick={onFinishEditing}
      >
        Finish Editing
      </button>
    </div>
  </div>
);

export default DrawingToolBox;
